import { createFileRoute } from '@tanstack/react-router'
import { QuizTrash } from './QuizTrash'

export const Route = createFileRoute('/quiz_/trash/')({
  component: () => <QuizTrash />,
})
